import Vue from 'vue'
import JsonApiObject from '@/_models/JsonApi'

export default class CompanyModel extends JsonApiObject {
    static async search(filters) {
        let query = {
            filters,
        }

        let res = await Vue.prototype.$vbit.get('company', `companies`, query)

        let companies = res.data.map((company) => new CompanyModel(company, res.included))

        return companies
    }

    static async get(id: string) {
        let res = await Vue.prototype.$vbit.get('company', `companies/${id}`)

        return new CompanyModel(res.data, res.included)
    }

    orgNo
    name
    nationality
    _contractor

    public constructor(public data: any, public included?: any) {
        super(data, included)
    }

    public clone() {
        return new CompanyModel(this.data, this.included)
    }

    get companyName() {
        return this['name']
            ? this['name']
            : this['displayName']
            ? this['displayName']
            : this['officialName']
    }

    get companyNumber() {
        return this['orgNo']
    }
}
